/*@flow*/
import type { Node } from 'react';
import React, { Fragment } from 'react';
import Dot from 'comps/Dot';
import type { ProjectT } from './types';
import useCommands from 'comps/Left2/useCommands';
import panels from 'comps/Left2/panels';

type PropsT = { records: ProjectT[] };

function FewerThan10Records({ records }: PropsT) {
  const cmd = useCommands();

  return records.map((v) => {
    function showItem() {
      cmd.showItemView(v);
      cmd.openPanel(panels.LOCATION_DETAILS);
    }
    return (
      <button
        onClick={showItem}
        className="text-left btn-link p-0 mb-2 d-block"
        key={v.id}
      >
        <Dot
          dotStyle="fill"
          type="circle"
          color={v.fillColor || 'white'}
          containerStyle={{ top: 0 }}
        />{' '}
        {v.name}
      </button>
    );
  });
}

function GreaterThan10Records(props: PropsT) {
  const cmd = useCommands();

  const { records } = props;
  const num = records.length;
  const item = records[0];
  if (!item) return null;
  const { latlon } = item;
  if (!latlon) return null;
  const [lat, lon] = latlon;
  const v = { focusedLatlon: { lat, lon } };

  return (
    <button
      onClick={() => cmd.showListView(v)}
      className="text-left btn-link p-0 mb-2 d-block"
    >
      {num} records
    </button>
  );
}

export default function MultiRecord(props: PropsT): Node {
  const { records } = props;

  const Component =
    records.length > 10 ? GreaterThan10Records : FewerThan10Records;

  return (
    <Fragment>
      <div className="project-popup-list">
        <Component {...props} />
      </div>
    </Fragment>
  );
}
